import { render, staticRenderFns } from "./ExampleProductList.vue?vue&type=template&id=67af463c&scoped=true&"
import script from "./ExampleProductList.vue?vue&type=script&lang=js&"
export * from "./ExampleProductList.vue?vue&type=script&lang=js&"
import style0 from "./ExampleProductList.vue?vue&type=style&index=0&id=67af463c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af463c",
  null
  
)

component.options.__file = "ExampleProductList.vue"
export default component.exports